<div class="hub-container">
  <mat-card class="hub-intro">
    <mat-card-content>
      <h1 class="hub-heading primary-color">Welcome to the Supportis Hub</h1>
      <p class="hub-welcome">
        Please use the links below to access the relevant services you are subscribed to.
      </p>

      <div class="hub-contacts fx-layout-row fx-gap-20">
        @for (contact of contacts; track contact.phone) {
          <div class="hub-contact">
            <span class="hub-contact-label">{{ contact.label }}</span>
            <a class="hub-contact-link" href="tel:{{ contact.phone }}">
              <mat-icon>call</mat-icon>{{ contact.phone }}
            </a>
          </div>
        }
      </div>

      <div class="hub-emails fx-layout-row fx-gap-20">
        @for (contact of contacts; track contact.email) {
          <a class="hub-email" href="mailto:{{ contact.email }}">
            <mat-icon>mail</mat-icon>{{ contact.email }}
          </a>
        }
      </div>

      <div class="hub-notes fx-layout-row fx-gap-20">
        @for (contact of contacts; track contact.phone) {
          <span class="hub-contact-note">{{ contact.note }}</span>
        }
      </div>
    </mat-card-content>
  </mat-card>

  <div class="hub-services fx-layout-row-wrap fx-gap-20">
    @for (service of services; track service.url) {
      <mat-card class="hub-service-card" (click)="openService(service.url)">
        <mat-card-content class="hub-service-content">
          <img class="hub-service-logo" [src]="service.img" [alt]="service.title" />
          <span class="hub-service-subtitle">{{ service.subtitle }}</span>
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
